import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import { CoreBox } from '@youscience/core';

import { sxStyles, StyledCardWrap, StyledActionsWrap } from './BaseScholarshipCard.styles';

export interface ScholarshipCardSkeletonProps {
  isWiderCardType?: boolean;
}

export const ScholarshipCardSkeleton = (props: ScholarshipCardSkeletonProps) => {
  const { isWiderCardType = false } = props;

  return (
    <StyledCardWrap isWiderCardType={isWiderCardType}>
      <CoreBox sx={sxStyles.cardContentWrap}>
        <Stack spacing={3} direction="row">
          <Skeleton variant="rounded" width={20} height={20} />

          <Skeleton variant="rounded" width="100%" height={20} />
        </Stack>

        <Skeleton sx={{ margin: '1.5rem 0' }} variant="rounded" width="100%" height={22} />

        <Skeleton variant="rounded" width="75%" height={10} />

        <Stack spacing={1} direction="column" marginTop={6} marginBottom={6}>
          <Skeleton variant="rounded" width="100%" height={22} />

          <Skeleton variant="rounded" width="100%" height={22} />

          <Skeleton variant="rounded" width="75%" height={22} />
        </Stack>

        <Skeleton variant="rounded" width="75%" height={10} />
      </CoreBox>

      <StyledActionsWrap>
        <Skeleton variant="rounded" width="100%" height={32} />
      </StyledActionsWrap>
    </StyledCardWrap>
  );
};
